<template>
    <div class="physical-storage--sub-warehouse">
        <div class="btn-list">
            <!-- <span class="btn" @click="getList"><i class="el-icon-document"></i>&nbsp;&nbsp;查询</span> -->
            <span class="btn bigData-btn-w-save" @click="handleSave">
                <i class="el-icon-document"></i>
                &nbsp;&nbsp;保存
            </span>
            <span class="btn bigData-btn-w-add" @click="handleAdd">
                <i class="el-icon-circle-plus-outline"></i>
                &nbsp;&nbsp;新增
            </span>
            <span class="btn bigData-btn-w-delete" v-if="!isQualified" @click="handleDelete">
                <i class="el-icon-delete"></i>
                &nbsp;&nbsp;删除物理子仓
            </span>
            <span
                class="btn bigData-btn-w-edit"
                v-if="isPrivilege || !isQualified"
                v-has="'lsrm/addPhysicalStorage-30'"
                @click="handleEdit">
                <i class="el-icon-edit-outline"></i>
                &nbsp;&nbsp;修改
            </span>
        </div>
        <el-table
            ref="subWhTable"
            :border="true"
            :data="tableData"
            @selection-change="handleSelect"
            @expand-change="handleExpand">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column type="expand">
                <template v-slot="props">
                    <fire-control-table
                        v-if="props.row.whCode"
                        :son-wh-code="props.row.whCode"
                        @refresh="handleRefresh" />
                </template>
            </el-table-column>
            <el-table-column v-for="item in columns" :key="item.prop" :prop="item.prop" :label="item.label" width="180" :show-overflow-tooltip="true">
                <template v-slot:header="scope">
                    <span class="table-header-mustFill" v-if="item.mustFillInSub">*</span>
                    {{ scope.column.label }}
                     <el-tooltip v-if="item.info" class="item" effect="dark" placement="bottom">
                            <div slot="content" v-html="item.info"></div>
                            <i class="el-icon-question"></i>
                    </el-tooltip>
                </template>
                <template v-slot="scope">
                    <div v-if="!scope.row.editable && item.type === 'upload'" class="img-flex">
                        <span v-if="scope.row[item.prop]">{{ item.label + '.png' }}</span>
                        <el-button
                            v-if="scope.row[item.prop]"
                            type="text"
                            @click="view(scope.row[item.prop])"
                            class="preview-btn">
                            预览
                        </el-button>
                    </div>
                    <span v-else-if="!scope.row.editable">{{ transformProp(scope.row[item.prop], item) }}</span>
                    <el-popover
                        v-else-if="item.prop === 'whName' || item.prop === 'whAddress'"
                        placement="bottom"
                        trigger="click"
                        :content="content[item.prop]">
                        <el-input
                            v-model.trim="scope.row[item.prop]"
                            placeholder
                            slot="reference"
                            :disabled="item.disabledInSub"
                            @input="val => handleInput(val, item.prop, scope.row)"></el-input>
                    </el-popover>
                    <el-input
                        v-else-if="item.type === 'input' || item.type === 'weightedInput'"
                        v-model.trim="scope.row[item.prop]"
                        :disabled="item.disabledInSub"></el-input>
                    <template v-else-if="item.type === 'mSelect'">
                        <mSelect2
                            v-if="item.prop === 'propertyType'"
                            :disabledOptions="disabledPropertyTypeArr"
                            :optionArr="propertyTypeArr"
                            :value="scope.row[item.prop]"
                            :flag="item.label"
                            :prop="item.prop"
                            :filterable="false"
                            :disabled="item.disabledInSub"
                            @input="data => propsChange(data, item.prop, scope.$index)"></mSelect2>
                        <m-select
                            v-else
                            :option-num="item.optionNum"
                            :value="scope.row[item.prop]"
                            :flag="item.label"
                            :prop="item.prop"
                            :filterable="false"
                            :disabled="item.disabledInSub"
                            @input="data => propsChange(data, item.prop, scope.$index)"></m-select>
                    </template>
                    <el-date-picker
                        v-else-if="item.type === 'date'"
                        value-format="yyyy-MM-dd"
                        v-model="scope.row[item.prop]"
                        type="date"
                        :disabled="item.disabledInSub"></el-date-picker>
                    <otp-advance
                        v-else-if="item.type === 'advance'"
                        :title="item.name"
                        :form-data="scope.row"
                        :prop="item.prop"
                        :m-value="scope.row[item.prop]"
                        :params="item"
                        :disabled="item.disabledInSub"
                        @getAdvanceValue="data => getAdvanceValue(data, scope.$index)"></otp-advance>
                    <div v-else-if="item.type === 'upload'" class="img-flex">
                        <el-input
                            :value="scope.row[item.prop] ? item.label : '请上传' + item.label"
                            class="sub-warehouse--upload-input">
                            <template v-slot:append>
                                <register-upload
                                    :disabled="item.disabled"
                                    upload-display-type="icon"
                                    :accept="'image/*'"
                                    :flag="{
                                        label: item.label,
                                        index: scope.$index,
                                        fileName: '',
                                        fileUrl: '',
                                        fileId: '',
                                    }"
                                    :size-limit="20"
                                    @uploadSuccess="
                                        data => uploadSuccessImg(data, item.prop, scope.$index)
                                    "></register-upload>
                            </template>
                        </el-input>
                        <el-button
                            v-if="scope.row[item.prop]"
                            type="text"
                            @click="view(scope.row[item.prop])"
                            class="preview-btn">
                            预览
                        </el-button>
                    </div>
                </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="100">
                <template v-slot="scope">
                    <el-button
                        v-if="scope.row.whCode"
                        @click="handleAddFireControl(scope.row)"
                        type="text"
                        size="small">
                        新增消防分区
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <m-page
            ref="page"
            :current-page="currentPage"
            :page-data="pageData"
            :total="total"
            @on-page-change="pageChange"
            @on-size-change="sizeChange"></m-page>
        <fire-control-dialog ref="fireControlDialog" @refresh="handleRefresh" />
        <preview v-if="attachmentShow" :attachment-show.sync="attachmentShow" :row-data="previewData" />
    </div>
</template>
<script>
import mPage from '@/components/supplierPanel/mPage'
import config from './subConfig.js'
import OtpAdvance from '../../../../../components/bulletFrame/otpAdvance/index.vue'
import MSelect from '../../../../../components/Select.vue'
import MSelect2 from '@/components/lots/otpSelect2';
import RegisterUpload from '../../../../../components/upload/Index.vue'
import Preview from '../../../../../components/viewAttachment.vue'
import FireControlTable from './FireControlTable.vue'
import FireControlDialog from './FireControlDialog.vue'
import { form, WH_STATUS } from './initData.js'
import { dictWithUrl } from '@/components/lots/api'
import {
    searchWarehouseSons,
    getWarehouseSon,
    addWarehouseSons,
    editWarehouseSons,
    delWarehouseSons,
} from '../../../../../api/addPhysicalStorage.js'
import { landlinePhoneVerify } from '../../../../../constant/formRegular.js'

export default {
    name: 'SubWarehouse',
    components: { mPage, MSelect, MSelect2, OtpAdvance, RegisterUpload, FireControlTable, FireControlDialog, Preview },
    props: {
        initData: {
            type: Object,
            default() {
                return JSON.parse(JSON.stringify(form))
            },
        },
        whStatus: {
            type: String,
            default() {
                return null
            },
        },
        isPrivilege: {
            type: Boolean,
            default() {
                return false
            },
        },
    },
    data() {
        return {
            columns: config.list,
            tableData: [],
            selected: [],
            dict: {},
            total: 0,
            currentPage: 1,
            pageData: {
                pageSize: 10,
                pageSizes: [10, 50, 100],
                layout: 'total, sizes, prev, pager, next, jumper',
            },
            content: {
                whName: '子仓名称：原物理仓名称+X号库（可按园区自有编号）',
                whAddress: '原物理仓地址+自编X号库（可按园区自有编号）',
            },
            previewData: { downUrl: '' }, // 图片预览对象
            attachmentShow: false, // 附件预览弹窗展示
            disabledPropertyTypeArr: ['3', '4', '6', '7', '8'], //置灰产权属性字典
            propertyTypeArr: [],
        }
    },
    computed: {
        isQualified() {
            // 仓库状态 合格
            return this.whStatus === WH_STATUS.QUALIFIED
        },
    },
    methods: {
        handleSelect(data) {
            this.selected = data
        },
        handleSave() {
            if (this.validate()) {
                if (this.selected[0].operateType === 'add') {
                    addWarehouseSons(this.getParams()).then(res => {
                        if (res && +res.code === 0) {
                            this.$message.success('新增成功!')
                            this.getList()
                        }
                    })
                } else if (this.selected[0].operateType === 'edit') {
                    editWarehouseSons(this.getParams()).then(res => {
                        if (res && +res.code === 0) {
                            this.$message.success('编辑成功!')
                            this.getList()
                        }
                    })
                }
            }
        },
        getParams() {
            const params = { ...this.selected[0], whParentCode: this.$route.query.whCode }
            delete params.createUserCode
            delete params.createUserName
            delete params.createTime
            delete params.updateUserCode
            delete params.updateUserName
            delete params.updateTime
            return params
        },
        handleAdd() {
            const data = JSON.parse(
                JSON.stringify({ ...this.initData, whCode: '', contractStatus: '2', usableArea: '0' }),
            )
            data.addressCode = null
            data.editable = true
            data.operateType = 'add'
            this.tableData.unshift(data)
        },
        handleDelete() {
            if (this.selected.length !== 1) {
                this.$message.warning('请选择单条数据进行操作!')
                return false
            }
            // 新增还未保存的数据直接删除
            if (this.selected[0].operateType === 'add') {
                const index = this.tableData.indexOf(this.selected[0])
                this.tableData.splice(index, 1)
                return
            }
            this.$confirm('是否确定删除?', '子仓库删除', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            })
                .then(() => {
                    delWarehouseSons(this.selected[0].id).then(res => {
                        if (res && +res.code === 0) {
                            this.$message.success('删除成功!')
                            this.getList()
                        }
                    })
                })
                .catch(() => {})
        },
        handleEdit() {
            if (this.selected.length && this.selected[0].operateType !== 'add') {
                const index = this.tableData.indexOf(this.selected[0])
                this.tableData[index].editable = true
                this.tableData[index].operateType = 'edit'
            }
        },
        propsChange(value, prop, index) {
            this.tableData[index][prop] = value
        },
        getAdvanceValue(data, index) {
            // console.log('getAdvanceValue', data);
            if (data.hasOwnProperty('ebplCode')) {
                this.tableData[index].cityCode = data.ebplCode
                this.tableData[index].cityName = data.ebplNameCn
                // } else if (data.hasOwnProperty('eblcCode')) {
                //     Object.keys(data).forEach(el => {
                //         this.tableData[index][el] = data[el];
                //     });
                //     this.tableData[index].addressCode = data.eblcCode;
                //     this.tableData[index].whAddress = data.eblcDetailAddress;
            } else if (data.hasOwnProperty('companyCode')) {
                this.tableData[index].companyCode = data.companyCode
                this.tableData[index].companyName = data.companyNameCn
            }
        },
        transformProp(value, col) {
            let data = null
            if (col.type === 'mSelect') {
                data = this.dict[col.optionNum] ? this.dict[col.optionNum][value] : ''
            } else {
                data = value
            }
            return data
        },
        pageChange(data) {
            this.currentPage = data
            this.getList()
        },
        sizeChange(data) {
            this.pageData.pageSize = data
            this.getList()
        },
        getList() {
            let whCode = this.$route.query.whCode
            if(!whCode) {
                return false
            }
            searchWarehouseSons({
                whParentCode: whCode,
                pageNo: this.currentPage,
                pageSize: this.pageData.pageSize,
            }).then(res => {
                if (res && +res.code === 0) {
                    this.tableData = this.format(res.data.list)
                    this.total = res.data.totalCount
                }
            })
        },
        validate() {
            let flag = true
            if (this.selected.length !== 1) {
                this.$message.warning('请选择单条数据进行操作!')
                flag = false
            } else {
                const { contactsPhone, contractStatus } = this.selected[0]
                // 校验必填
                let mustFillColumns = this.columns.filter(col => col.mustFillInSub)
                // 合同状态，1 表示 在用
                if (+contractStatus === 1) {
                    mustFillColumns = mustFillColumns.concat([
                        { label: '产权属性', prop: 'propertyType' },
                        { label: '产权人', prop: 'propertyOwner' },
                    ])
                }
                const mustFillLabels = []
                mustFillColumns.forEach(col => {
                    if (!this.selected[0][col.prop] || !this.selected[0][col.prop].trim()) {
                        mustFillLabels.push(col.label)
                    }
                })
                // 校验正数
                const positiveNumColumns = this.columns.filter(col => col.isPositiveNum)
                const positiveNumLabels = []
                positiveNumColumns.forEach(col => {
                    if (this.selected[0][col.prop] && !/^\d{1,8}(\.\d{1,2})?$/.test(this.selected[0][col.prop])) {
                        positiveNumLabels.push(col.label)
                    }
                })
                // 最大长度校验
                const exceedMaxMsg = []
                this.columns
                    .filter(col => !!col.max)
                    .forEach(col => {
                        if (this.selected[0][col.prop] && this.selected[0][col.prop].length > col.max) {
                            exceedMaxMsg.push(`${col.label}字符长度不能大于${col.max}位`)
                        }
                    })

                if (mustFillLabels.length) {
                    this.$message.warning(`${mustFillLabels.join(', ')} 不能为空!`)
                    flag = false
                } else if (contactsPhone && !landlinePhoneVerify.test(contactsPhone)) {
                    this.$message.warning('联系电话填写有误，请使用手机号或固话!')
                    flag = false
                } else if (positiveNumLabels.length) {
                    this.$message.warning(`${positiveNumLabels.join(', ')} 最多8位整数，保留两位小数!`)
                    flag = false
                } else if (exceedMaxMsg.length) {
                    this.$message.warning(exceedMaxMsg.join('; '))
                    flag = false
                }
            }
            return flag
        },
        format(data) {
            return data.map(item => {
                Object.keys(item).forEach(key => {
                    if (typeof item[key] === 'number') {
                        item[key] = String(item[key])
                    }
                })
                item.editable = false
                return item
            })
        },
        handleAddFireControl(row) {
            this.$refs.fireControlDialog.openToAdd(row.whCode)
        },
        handleExpand(row, expandedRows) {
            // console.log(row, expandedRows);
            // this.$nextTick(() => {
            //     console.log(this.$refs);
            //     // console.log(this.$refs);
            //     const expanded = expandedRows.some(eRow => eRow.id === row.id);
            //     const index = this.tableData.findIndex(eRow => eRow.id === row.id);
            //     if (expanded) {
            //         this.$refs['fireControlTable' + index].load(row.whCode);
            //     }
            // });
        },
        handleRefresh(whCode) {
            const index = this.tableData.findIndex(eRow => eRow.whCode === whCode)
            getWarehouseSon(this.tableData[index].id).then(res => {
                if (res && +res.code === 0) {
                    this.tableData[index].usableArea = res.data.usableArea
                    this.tableData[index].contractStatus = res.data.contractStatus
                }
            })
            this.refreshFireControl(index)
        },
        refreshFireControl(index) {
            // 重新打开刷新数据
            this.$refs.subWhTable.toggleRowExpansion(this.tableData[index])
            this.$nextTick(() => {
                this.$refs.subWhTable.toggleRowExpansion(this.tableData[index])
            })
        },
        handleInput(val, prop, row) {
            if (prop === 'whName') {
                row.whAddress = this.initData.whAddress + val
            }
        },
        // 图片上传
        uploadSuccessImg(data, prop, index) {
            if (+data.data.code === 0) {
                this.$set(this.tableData[index], prop, data.data.data.downUrl)
                this.$message.success('上传成功!')
            }
        },
        /** 附件预览 **/
        view(data) {
            if (data) {
                this.attachmentShow = true
                this.previewData = { downUrl: data }
            } else {
                this.$message.warning('暂无可预览的文件!')
            }
        },
    },
    mounted() {
        const dictList = this.columns
            .filter(col => col.optionNum)
            .map(col => col.optionNum)
            .join(',')
        dictWithUrl(dictList).then(res => {
            if (res && +res.code === 0) {
                this.dict = res.data

                // 产权属性字典按这个字典编码进行排序  ['1','2','9'] 
                const propertyTypeArr = ['1','2','9']
                //查找出不在编码排序内的选项
                const propertyTypeOpts = Object.keys(res.data['SYS_PROPERTY_RIGHTS']).filter(v => propertyTypeArr.indexOf(v) === -1 && this.disabledPropertyTypeArr.indexOf(v) === -1)
                //将固定顺序的选项（已启用）与不在顺序内的选项合并，后者选项排后面
                const newPropertyTypeOpts = [...(propertyTypeArr.filter(v => res.data['SYS_PROPERTY_RIGHTS'][v])),...propertyTypeOpts, ...this.disabledPropertyTypeArr]

                this.propertyTypeArr = newPropertyTypeOpts.map(v => {
                    return {
                        label: res.data['SYS_PROPERTY_RIGHTS'][v],
                        value: v,
                    }
                })

                this.getList()
            }
        })
    },
}
</script>
<style lang="less">
.physical-storage--sub-warehouse {
    .table-header-mustFill {
        color: red;
    }

    .img-flex {
        display: flex;
        justify-content: space-around;
        align-items: center;
    }

    .sub-warehouse--upload-input {
        .el-input__inner {
            border-right: none;
        }

        .el-input-group__append {
            padding: 0 5px;
            color: #33c9cc;
            background-color: transparent;
            border-left: none;
        }
    }

    .preview-btn {
        margin-left: 5px;
    }
}
</style>
